module.exports = __webpack_public_path__ + "media/bell.f3e1419d.mp3";